import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DevNote,
  DocumentsList,
  LogoLoader,
  Modal,
  NewTable,
  TableAdv,
  SmartTooltip,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
} from "../../../../../components";
import { placementData } from "../../../../../assets/data/candidatesData";
import { dateFormator } from "../../../../../utils/dateFormator";
import { mapTableRows } from "../../../../../utils/mapTableRows";
/////
import { useSelector, useDispatch } from "react-redux";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { getAllPlacementsStart } from "../../../../../redux/slices/placements/placementsSlice";
import {
  BillRateType,
  CommissionType,
  PayType,
  TimesheetCycles,
  TimesheetFormat,
  Weekdays,
  WorkLocationType,
} from "../../../../../assets/data/enumData";
import { useNavigate } from "react-router-dom";
import { transformFiles } from "../../../../../utils/transformFiles";
import { formatCurrency, formatWords2 } from "../../../../../utils/stringUtils";
import { pre } from "framer-motion/client";
import {
  invoiceCalculationTypeOptions,
  invoiceFrequencyTypeOptions,
} from "../../../../../assets/data/projectData";
import {
  getINRPayRate,
  getUSPayRate,
} from "../../../../../utils/wf/placements.logic";
/////
const Placement = ({ onEdit }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectDocuments] = useState([]);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid,
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee,
  );
  const { placements } = employeeDetails || {};

  const { placements: placementsTableData, isLoading } = useSelector(
    (state) => state.placement,
  );
  const [previewData, setPreviewData] = useState({
    preview: [],
    data: [],
  });
  // console.log("placements", placements);
  const tableData = placementsTableData?.data || [];

  // const setterPreviewData = (data) => {
  //   showToast("Previewing Placement Data");
  //   console.log("data", data);
  //   //client placement mapper
  //   let previewDataMapper = {
  //   General: {
  //     "Billable Client": data?.jobInfo?.billClient?.businessName,
  //     },
  //   Other: {
  //     "Vendor Name": data?.vendor?.id?.businessName,
  //     }
  // };
  //   setPreviewData(previewDataMapper);
  // };
  const setterPreviewData = (data) => {
    let previewDataMapper = [];
    if (data?.type === 1) {
      let latestpayments = data?.payments[data?.payments.length - 1] || {};
      console.log({ latestpayments });
      const inrPay = getINRPayRate(data?.payments);
      const approverEntries = Array.isArray(data?.timesheetDetails?.approvers)
        ? data.timesheetDetails.approvers.map((approver, index) => {
            const type = approver.type === 1 ? "Internal" : "External";
            const manager =
              approver?.id?.[0]?.firstName + " " + approver?.id?.[0]?.lastName;
            return {
              [`Approver ${index + 1}`]: `${type} - ${manager}`,
            };
          })
        : [{ "Approver 1": "--" }];
      previewDataMapper = [
        {
          section: "General",
          data: {
            Client: data?.jobInfo?.billClient?.businessName || "-",
            Vendor: data?.vendor?.id?.businessName || "-",
            Placement: data?.clientPlacement?.placement || "-",
            "Job Code": data?.jobInfo?.jobCode || "-",
            "Job Title": data?.jobInfo?.jobTitle || "-",
            "Start Date": data?.jobInfo?.startDate || "-",
            "End Date": data?.jobInfo?.endDate || "-",
            "Job Status": data?.jobInfo?.status === 1 ? "Active" : "Inactive",
          },
        },
        {
          section: "Payments",
          data: {
            "Effective Date": latestpayments?.payRate?.effectiveDate,
            "Billing Type":
              BillRateType.find(
                (item) => item.value === latestpayments?.billRate?.type,
              )?.label || "-",
            "Bill Rate": formatCurrency(latestpayments?.billRate?.rate) || "-",
            "VMS Charges": latestpayments?.vmsCharges
              ? `${latestpayments?.vmsCharges} %`
              : "-",
            // "Pay Type": latestpayments?.payRate?.payType || "-",
            "Pay Type":
              PayType.find(
                (item) => item.value === latestpayments?.payRate?.payType,
              )?.label || "-",
            "Purchase Order Number": latestpayments?.poNum || "-",
            "Pay Rate / Hr":
              // getUSPayRate(data?.payments) || "-",
              formatCurrency(getUSPayRate(data?.payments)) || "-",
            "Other Pay Rate / Hr":
              inrPay === "-" ? "-" : formatCurrency(inrPay),
            Percentage: !isNaN(latestpayments?.payRate?.percent)
              ? `${latestpayments?.payRate?.percent} %`
              : "-",
            "Purchase Order Attachment": {
              value: latestpayments?.poLink?.length
                ? `${latestpayments?.poLink?.length} Attachments`
                : "-",
              metadata:
                latestpayments?.poLink?.map((d) => ({
                  filePath: d,
                  name: "PO Attachment",
                })) || [],
            },
          },
        },
        {
          section: "Timesheet Details",
          data: {
            // "Timesheet Cycles":data?.timesheetDetails?.submissionSettings?.cycles || "-",
            "Timesheet Cycles":
              TimesheetCycles.find(
                (item) =>
                  item.value ===
                  data?.timesheetDetails?.submissionSettings?.cycles,
              )?.label || "-",
            "Week Start Day":
              Weekdays.find(
                (item) =>
                  item.value ===
                  data?.timesheetDetails?.submissionSettings?.weekStartDay,
              )?.label || "-",
            "Timesheet Attachment": data?.timesheetDetails?.submissionSettings
              ?.attachmentMandatory
              ? "Mandatory"
              : "Not Mandatory",
            "Timesheet Start Date":
              data?.timesheetDetails?.submissionSettings?.startDate || "-",
            "Allowable Period to Submit Timesheets":
              data?.timesheetDetails?.submissionSettings?.submitPeriod || "-",
            // "Timesheet Format":
            //   data?.timesheetDetails?.submissionSettings?.format || "-",
            "Timesheet Format":
              TimesheetFormat.find(
                (item) =>
                  item.value ===
                  data?.timesheetDetails?.submissionSettings?.format,
              )?.label || "-",
          },
        },
        {
          section: "Approval Flow",
          data: {
            // Approvers: Array.isArray(data?.timesheetDetails?.approvers)
            //   ? data.timesheetDetails.approvers
            //       .map((approver) => {
            //         const type = approver.type === 1 ? "Internal" : "External";
            //         const manager =
            //           approver?.id?.[0]?.firstName +
            //           " " +
            //           approver?.id?.[0]?.lastName;
            //         return `${type} - ${formatWords2(manager)}`;
            //       })
            //       .join(", ")
            //   : "--",
            ...approverEntries.reduce((acc, item) => ({ ...acc, ...item }), {}),
          },
        },
        {
          section: "Invoices ",
          data: {
            // "Invoice Calculation Type": data?.invoices?.calcType || "-",
            "Invoice Calculation Type":
              invoiceCalculationTypeOptions.find(
                (item) => item.value === data?.invoices?.calcType,
              )?.label || "-",
            "Invoice Frequency":
              invoiceFrequencyTypeOptions.find(
                (item) => item.value === data?.invoices?.frequency,
              )?.label || "-",
            "Frequency Start Date": data?.invoices?.frequencyStartDate || "-",
            "Include PO Number": data?.invoices?.includePONum
              ? "Yes "
              : " No" || "-",
            "Funding/Non-funding": data?.invoices?.isFunded
              ? "Yes "
              : " No" || "-",
            "Additional Info": data?.invoices?.additionalInfo || "-",
          },
        },
        {
          section: "Documents",
          data: {
            "Total Documents": data?.documents?.length || 0,
          },
        },
        {
          section: "Work Location",
          data: {
            "Work Location Type":
              WorkLocationType.find(
                (item) =>
                  item.value === data?.clientPlacement?.workLocation?.type,
              )?.label || "-",
            "Work Email": data?.clientPlacement?.workLocation?.workEmail || "-",
            "Work Phone Number": data?.clientPlacement?.workLocation?.phone
              ?.number
              ? data?.clientPlacement?.workLocation?.phone?.code +
                "-" +
                data?.clientPlacement?.workLocation?.phone?.number
              : "" || "-",
            "Address Line 1":
              data?.clientPlacement?.workLocation?.address?.address1 || "-",
            "Address Line 2":
              data?.clientPlacement?.workLocation?.address?.address2 || "-",
            City: data?.clientPlacement?.workLocation?.address?.city || "-",
            State: data?.clientPlacement?.workLocation?.address?.state || "-",
            Country:
              data?.clientPlacement?.workLocation?.address?.country || "-",
            // "Work Location Type":
            //   data?.clientPlacement?.workLocation?.type || "-",
            "Zip Code":
              data?.clientPlacement?.workLocation?.address?.zipCode || "-",
            "Amendment Required": data?.clientPlacement?.workLocation?.amendment
              ? "Yes"
              : "No" || "-",
          },
        },
      ];
    } else if (data?.type === 2) {
      const latestpayments = data?.payments[data?.payments.length - 1] || {};
      previewDataMapper = [
        {
          section: "Job Details",
          data: {
            Client: data?.jobInfo?.billClient?.businessName || "-",
            "Job Code": data?.jobInfo?.jobCode || "-",
            "Job Title": data?.jobInfo?.jobTitle || "-",
            "Job Status": data?.jobInfo?.status === 1 ? "Active" : "Inactive",
            "Start Date": data?.jobInfo?.startDate || "-",
            "End Date": data?.jobInfo?.endDate || "-",
          },
        },
        {
          section: "Payments",
          data: {
            "Annual Salary of Consultant": formatCurrency(
              latestpayments?.annualPay,
            ),
            // "Commission Type": latestpayments?.commission?.type || "-",
            "Commission Type":
              CommissionType.find(
                (item) => item.value === latestpayments?.commission?.type,
              )?.label || "-",
            "Commission Value": latestpayments?.commission?.value || "-",
            "PO Number": latestpayments?.poNum || "-",
            Comments: latestpayments?.comments || "-",
            Aggreement: latestpayments?.hasAgreement?.type
              ? "Yes"
              : "No" || "-",
            "Offer Letters": latestpayments?.hasOffer?.type
              ? "Yes"
              : "No" || "-",
          },
        },
        {
          section: "Invoices Details",
          data: {
            "Invoice Period": data?.invoices?.period || "-",
            "Invoice Date": data?.invoices?.invoiceDate || "-",
            "Include PO Number": data?.invoices?.invoiceDate
              ? "Yes"
              : "No" || "-",
            // "Include Aggreement Attachment": data?.invoices?.invoiceDate || "-",
            "Include Aggreement Attachment": "-",
            "Funding / Non Funding": data?.invoices?.isFunded
              ? "Yes"
              : "No" || "-",
            "Additional Info": data?.invoices?.additionalInfo || "-",
            "Enter CC Email ID":
              data?.invoices?.cc?.map((e) => e).join(", ") || "-",
          },
        },
        {
          section: "Billing & Notifications",
          data: {
            "Point of Contact Name":
              data?.invoices?.billNNotify?.POCName || "-",
            To:
              data?.invoices?.billNNotify?.to?.map((e) => e).join(", ") || "-",
            CC:
              data?.invoices?.billNNotify?.cc?.map((e) => e).join(", ") || "-",
            BCC:
              data?.invoices?.billNNotify?.bcc?.map((e) => e).join(", ") || "-",
            "Invoice Billing Address":
              data?.invoices?.billNNotify?.billingAddress || "-",
          },
        },
        {
          section: "Quickbooks Integration",
          data: {
            "Item Income Account":
              data?.invoices?.qBIntegration?.itemIncomeAcc || "-",
            "Item Category": data?.invoices?.qBIntegration?.itemCategory || "-",
            "Sub-Customer": data?.invoices?.qBIntegration?.subCustomer || "-",
            "Line Item": data?.invoices?.qBIntegration?.lineItem || "-",
            "Item Class": data?.invoices?.qBIntegration?.itemClass || "-",
          },
        },
        {
          section: "Discounts",
          data: {
            "Discount Name": data?.invoices?.discount?.name || "-",
            "Discount Type":
              data?.invoices?.discount?.type === 1
                ? "Value"
                : data?.invoices?.discount?.type === 2
                  ? "Percentage"
                  : "-" || "-",
            "Discount Value":
              formatCurrency(data?.invoices?.discount?.value) || "-",
          },
        },
        {
          section: "Documents",
          data: {
            "Total Documents": data?.documents?.length
              ? `${data?.documents?.length} Documents`
              : `` || 0,
          },
        },
      ];
    } else {
      previewDataMapper = [];
    }

    setPreviewData({ preview: previewDataMapper, data: data });
  };

  const columns = [
    {
      key: "jobCode",
      label: "Job Code",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobInfo?.jobCode}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => {
            setIsPreviewModal((prev) => !prev);
            setterPreviewData(row);
          }}
        >
          <span className="text-linkblue line-clamp-1">{row?.jobInfo?.jobCode}</span>
        </div>
        </SmartTooltip>
      ),
      sortable: false,
    },
    // {
    //   key: "placementCode",
    //   label: "Placement Code",
    //   sortable: false,
    // },
    {
      key: "placementCode",
      label: "Placement Type",
      sortable: false,
      render: (row) => {
        return <div>{row?.clientPlacement?.placement || "-"}</div>;
      },
    },
    {
      key: "jobTitle",
      label: "Job Title",
      sortable: false,
      width:"min-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobInfo?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <div className="line-clamp-1!">{row?.jobInfo?.jobTitle}</div>{" "}
        </SmartTooltip>
      ),
    },
    {
      key: "billableClient",
      label: "Billable Client",
      sortable: false,
      width:"min-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobInfo.billClient?.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal
        >
          <div className="line-clamp-1!">{row?.jobInfo.billClient?.businessName}</div>{" "}
        </SmartTooltip>
      ),
    },
    {
      key: "vendorname",
      label: "Vendor Name",
      sortable: false,
      render: (row) => row?.vendor?.id?.businessName || "-",
    },
    // {
    //   key: "projectTitle",
    //   label: "Project Title",
    //   sortable: false,
    //   render: (row) => row?.clientPlacement?.project,
    // },
    {
      key: "jobStatus",
      label: "Job Status",
      render: (row) => (
        <StatusTags tag={row?.jobInfo?.status === 1 ? "Active" : "Inactive"} />
      ),
      sortable: false,
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row?.jobInfo?.startDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row?.jobInfo?.endDate, "month-day-year"),
      sortable: false,
    },
    // {
    //   key: "projectedEndDate",
    //   label: "Projected End Date",
    //   render: (row) =>
    //     dateFormator(row?.jobInfo?.projectEndDate, "month-day-year"),
    //   sortable: false,
    // },
    {
      key: "payRate",
      label: "Pay Rate",
      render: (row) => formatCurrency(getUSPayRate(row?.payments)),
      sortable: false,
    },
    {
      key: "indiaPayRate",
      label: "Other Pay Rate",
      render: (row) => formatCurrency(getINRPayRate(row?.payments)),
      sortable: false,
    },
    {
      key: "billRate",
      label: "Bill Rate",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return <div>{paymentsLast?.billRate?.rate || ""}</div>;
      },
      sortable: false,
    },
    {
      key: "vmsCharges",
      label: "Vms Charges",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return <div>{paymentsLast?.vmsCharges ?? "-"}</div>;
      },
      sortable: false,
    },
    // {
    //   key: "BillRateType",
    //   label: "BillRate Type",
    //   render: (row) =>{
    //     const payments=row?.payments||[];
    //     const paymentsLast=payments[payments.length-1];
    //     const findLable=BillRateType.find((data)=>data.value===paymentsLast?.type)
    //     return(
    //        <div>{findLable?.label||""}</div>
    //   )
    // },
    //   sortable: false,
    // },

    {
      key: "paymentEffectiveDate",
      label: "Payment Effective Date",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return (
          <div>
            {paymentsLast?.payRate?.effectiveDate
              ? dateFormator(
                  paymentsLast?.payRate?.effectiveDate,
                  "month-day-year",
                )
              : ""}
          </div>
        );
      },
      sortable: false,
    },
    {
      key: "addedOn",
      label: "Created Date",
      render: (row) => dateFormator(row?.addedOn, "month-day-year"),
      sortable: false,
    },
    // {
    //   key: "action",
    //   label: "Termination Notice",
    //   sortable: false,
    // },
    {
      key: "actions",
      label: "Actions",
      render: (row) => {
        const payments = row?.payments || [];
        const lastPayments = payments[payments.length - 1] || {}; // Ensure lastPayments is an empty object if not found

        // Mapping the purchase order links
        const poLink =
          (lastPayments?.poLink || []).map((data) => ({
            name: "Purchase Order",
            filePath: data,
          })) || []; // Ensure poLink is an empty array if no data

        // Mapping offer letters
        const offerDocuments =
          (lastPayments?.hasOffer?.documents || []).map((data) => ({
            name: "Offer Letter",
            filePath: data,
          })) || []; // Ensure offerDocuments is an empty array if no data

        // Mapping agreements
        const agreementDocuments =
          (lastPayments?.hasAgreement?.documents || []).map((data) => ({
            name: "Agreements",
            filePath: data,
          })) || []; // Ensure agreementDocuments is an empty array if no data

        // Handling invoices and documents
        const invoicesDocuments = row?.invoices?.invoices || [] || []; // Ensure invoicesDocuments is an empty array
        const documents = row?.documents || []; // Ensure documents is an empty array

        // Combine documents
        const combine = [...invoicesDocuments, ...documents];

        // Transform the files, but only if combine has data
        const updateDocuments =
          combine.length > 0 ? transformFiles(combine) : [];

        // Combine all documents into one array
        const combineDocuments = [
          ...updateDocuments,
          ...poLink,
          ...offerDocuments,
          ...agreementDocuments,
        ];
        return (
          <div className="flex gap-1">
            <Button
              type="icon"
              icon="edit_square"
              color="primary"
              variant="text"
              size="xs"
              onClick={() => onEdit(row)}
            />
            <Button
              type="icon"
              icon="content_copy"
              color="primary"
              variant="text"
              size="xs"
            />
            <Button
              type="icon"
              icon="docs"
              color="primary"
              variant="text"
              size="xs"
              onClick={() => {
                setSelectDocuments(combineDocuments);
                setDocumentModal(!documentModal);
              }}
            />
            <Button
              type="icon"
              icon="outgoing_mail"
              color="primary"
              variant="text"
              size="xs"
            />
          </div>
        );
      },
    },
  ];
  const columns2 = [
    {
      key: "jobCode",
      label: "Job Code",
      render: (row) => (
        // <div className="flex items-center gap-1 cursor-pointer" onClick={() => {
        //   setIsPreview((prev) => !prev);
        // }}>
        //   <span className="text-linkblue">{row?.jobInfo?.jobCode}</span>
        // </div>
        <div
          className="flex items-center gap-1 cursor-pointer"
          onClick={() => {
            setIsPreviewModal((prev) => !prev);
            setterPreviewData(row);
          }}
        >
          <span className="text-linkblue">{row?.jobInfo?.jobCode}</span>
        </div>
      ),
      sortable: false,
    },
    // {
    //   key: "placementCode",
    //   label: "Placement Code",
    //   sortable: false,
    // },
    {
      key: "placementCode",
      label: "Placement Type",
      sortable: false,
      render: (row) => {
        return <div>{row?.clientPlacement?.placement || "-"}</div>;
      },
    },
    {
      key: "jobTitle",
      label: "Job Title",
      sortable: false,
      render: (row) => row?.jobInfo?.jobTitle,
    },
    {
      key: "billableClient",
      label: "Billable Client",
      sortable: false,
      render: (row) => row?.jobInfo.billClient?.businessName || "-",
    },
    {
      key: "vendorname",
      label: "Vendor Name",
      sortable: false,
      render: (row) => row?.vendor?.id?.businessName || "-",
    },
    // {
    //   key: "projectTitle",
    //   label: "Project Title",
    //   sortable: false,
    //   render: (row) => row?.clientPlacement?.project,
    // },
    {
      key: "jobStatus",
      label: "Job Status",
      render: (row) => (
        <StatusTags tag={row?.jobInfo?.status === 1 ? "Active" : "Inactive"} />
      ),
      sortable: false,
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row?.jobInfo?.startDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row?.jobInfo?.endDate, "month-day-year"),
      sortable: false,
    },
    // {
    //   key: "projectedEndDate",
    //   label: "Projected End Date",
    //   render: (row) =>
    //     dateFormator(row?.jobInfo?.projectEndDate, "month-day-year"),
    //   sortable: false,
    // },
    {
      key: "payRate",
      label: "Pay Rate",
      render: (row) => formatCurrency(getUSPayRate(row?.payments)),
      sortable: false,
    },
    {
      key: "indiaPayRate",
      label: "Other Pay Rate",
      render: (row) => formatCurrency(getINRPayRate(row?.payments)),
      sortable: false,
    },
    {
      key: "billRate",
      label: "Bill Rate",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return <div>{paymentsLast?.billRate?.rate || ""}</div>;
      },
      sortable: false,
    },
    {
      key: "vmsCharges",
      label: "Vms Charges",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return <div>{paymentsLast?.vmsCharges ?? "-"}</div>;
      },
      sortable: false,
    },
    // {
    //   key: "BillRateType",
    //   label: "BillRate Type",
    //   render: (row) =>{
    //     const payments=row?.payments||[];
    //     const paymentsLast=payments[payments.length-1];
    //     const findLable=BillRateType.find((data)=>data.value===paymentsLast?.type)
    //     return(
    //        <div>{findLable?.label||""}</div>
    //   )
    // },
    //   sortable: false,
    // },

    {
      key: "paymentEffectiveDate",
      label: "Payment Effective Date",
      render: (row) => {
        const payments = row?.payments || [];
        const paymentsLast = payments[payments.length - 1];
        return (
          <div>
            {paymentsLast?.payRate?.effectiveDate
              ? dateFormator(
                  paymentsLast?.payRate?.effectiveDate,
                  "month-day-year",
                )
              : ""}
          </div>
        );
      },
      sortable: false,
    },
    {
      key: "addedOn",
      label: "Created Date",
      render: (row) => dateFormator(row?.addedOn, "month-day-year"),
      sortable: false,
    },
    // {
    //   key: "action",
    //   label: "Termination Notice",
    //   sortable: false,
    // },
    {
      key: "actions",
      label: "Actions",
      render: (row) => {
        const payments = row?.payments || [];
        const lastPayments = payments[payments.length - 1] || {}; // Ensure lastPayments is an empty object if not found

        // Mapping the purchase order links
        const poLink =
          (lastPayments?.poLink || []).map((data) => ({
            name: "Purchase Order",
            filePath: data,
          })) || []; // Ensure poLink is an empty array if no data

        // Mapping offer letters
        const offerDocuments =
          (lastPayments?.hasOffer?.documents || []).map((data) => ({
            name: "Offer Letter",
            filePath: data,
          })) || []; // Ensure offerDocuments is an empty array if no data

        // Mapping agreements
        const agreementDocuments =
          (lastPayments?.hasAgreement?.documents || []).map((data) => ({
            name: "Agreements",
            filePath: data,
          })) || []; // Ensure agreementDocuments is an empty array if no data

        // Handling invoices and documents
        const invoicesDocuments = row?.invoices?.invoices || [] || []; // Ensure invoicesDocuments is an empty array
        const documents = row?.documents || []; // Ensure documents is an empty array

        // Combine documents
        const combine = [...invoicesDocuments, ...documents];

        // Transform the files, but only if combine has data
        const updateDocuments =
          combine.length > 0 ? transformFiles(combine) : [];

        // Combine all documents into one array
        const combineDocuments = [
          ...updateDocuments,
          ...poLink,
          ...offerDocuments,
          ...agreementDocuments,
        ];
        return (
          <div className="flex gap-1">
            <Button
              type="icon"
              icon="edit_square"
              color="primary"
              variant="text"
              size="xs"
              onClick={() => onEdit(row)}
            />
            <Button
              type="icon"
              icon="content_copy"
              color="primary"
              variant="text"
              size="xs"
            />
            <Button
              type="icon"
              icon="docs"
              color="primary"
              variant="text"
              size="xs"
              onClick={() => {
                setSelectDocuments(combineDocuments);
                setDocumentModal(!documentModal);
              }}
            />
            <Button
              type="icon"
              icon="outgoing_mail"
              color="primary"
              variant="text"
              size="xs"
            />
          </div>
        );
      },
    },
  ];
  
  // console.log({ tableData });
  const now = new Date();
  
  const safeTableData = Array.isArray(tableData) ? tableData : [];
  
  const mappedRows = mapTableRows(
    safeTableData.filter((a) => {
      const endDate = new Date(a?.jobInfo?.endDate);
      return !isNaN(endDate) && endDate > now;
    }),
    columns
  );
  
  const mappedRows2 = mapTableRows(
    safeTableData.filter((a) => {
      const endDate = new Date(a?.jobInfo?.endDate);
      return !isNaN(endDate) && endDate < now;
    }),
    columns2
  );
  useEffect(() => {
    dispatch(
      getEmployeeByUiidStart({
        uiid: employeeProfileUiid,
        tab: "placementsTab",
        ret: "placements employmentType",
      }),
    );
  }, []);

  useEffect(() => {
    dispatch(
      getAllPlacementsStart({
        fil: { uiid: { type: "IN", value: placements } },
        cache: false,
        ref: "Client Document InvDoc Vendor Approver",
        incl: [
          "uiid businessName",
          "",
          "",
          "uiid businessName",
          "firstName lastName",
        ],
        //  ret:"uiid type jobInfo.jobCode jobInfo.billClient clientPlacement.placement jobInfo.jobTitle entityId clientPlacement.project jobInfo.status jobInfo.startDate jobInfo.endDate jobInfo.projectEndDate payments addedOn documents"
      }),
    );
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  return (
    <div className="my-4">
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Active Placements"} tag="h5" />
          </div>
        }
      />
      <div className="mb-10">
        <TableAdv
          tableId={"employee_placementstab1"}
          rows={mappedRows}
          columns={columns}
          // toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
          toolbarRight={{
            search: true,
            add: [
              {
                component: (
                  <div>
                    <Button title="Search" size="sm" />
                  </div>
                ),
              },
            ],
          }}
        />
      </div>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"Inactive Placements"} tag="h5" />
          </div>
        }
      />
      <NewTable
        rows={mappedRows2}
        columns={columns2}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        customSection={
          <div>
            <Button title="Search" size="sm" />
          </div>
        }
      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
        zIndex={"53"}
        closeOnOutsideClick
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>

      {/* <Modal
        width="max-w-6xl"
        title={"Placement Preview"}
        isOpen={isPreviewModal}
        onClose={() => setIsPreviewModal(false)}
      >
        <>
          {Array.isArray(previewData?.preview) &&
          previewData?.preview?.length > 0 ? (
            previewData?.preview?.map((section, index) => {
              const sectionTitle = section?.section || "Untitled Section";
              const sectionData = section?.data;

              // Skip invalid section data
              if (
                !sectionData ||
                typeof sectionData !== "object" ||
                Object.keys(sectionData).length === 0
              ) {
                return null;
              }

              return (
                <div key={index} className="mb-6">
                  <h2 className="text-lg font-semibold mb-2 border-b pb-1">
                    {sectionTitle}
                  </h2>

                  <div className="grid grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-6">
                    {Object.entries(sectionData).map(([key, value]) => {
                      const label = key || "Unknown Field";
                      const isDateValue = key?.toLowerCase?.().includes("date");

                      // Handle empty or missing values
                      let displayValue = "--";
                      if (
                        value !== null &&
                        value !== undefined &&
                        value !== ""
                      ) {
                        displayValue = isDateValue
                          ? dateFormator?.(value, "month-day-year") || "--"
                          : value;
                      }

                      return (
                        <div key={label} className="flex flex-col">
                          <span className="text-sm text-gray-500 font-semibold ">
                            {label}
                          </span>
                          <span className="text-base">{displayValue}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-gray-500 italic">No preview data available.</p>
          )}
          <div className="flex justify-center  mt-4 gap-2">
            <Button
              title={"Close"}
              variant="outlined"
              icon="close"
              onClick={() => setIsPreviewModal(false)}
            />
            <Button
              title={"Edit"}
              variant="contained"
              icon="edit"
              onClick={() => onEdit(previewData.data)}
            />
          </div>
        </>
      </Modal> */}
      <Modal
        width="max-w-6xl"
        title="Placement Preview"
        isOpen={isPreviewModal}
        onClose={() => setIsPreviewModal(false)}
      >
        <div className="max-h-[50vh] overflow-y-auto pr-2">
          {Array.isArray(previewData?.preview) &&
          previewData?.preview?.length > 0 ? (
            previewData.preview.map((section, index) => {
              const sectionTitle = section?.section || "Untitled Section";
              const sectionData = section?.data;

              if (
                !sectionData ||
                typeof sectionData !== "object" ||
                Object.keys(sectionData).length === 0
              ) {
                return null;
              }

              return (
                <div key={index} className="mb-6">
                  <h2 className="text-lg font-semibold mb-2 border-b   pb-1">
                    {sectionTitle}
                  </h2>

                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-4 gap-x-6">
                    {Object.entries(sectionData).map(([key, value]) => {
                      const label = key || "Unknown Field";
                      const isDateValue = key?.toLowerCase?.().includes("date");

                      let displayValue = "--";
                      if (
                        value !== null &&
                        value !== undefined &&
                        value !== ""
                      ) {
                        displayValue = isDateValue
                          ? dateFormator?.(value, "month-day-year") || "--"
                          : // value
                            value;
                      }
                      if (key === "Purchase Order Attachment") {
                        return (
                          <div key={label} className="flex flex-col">
                            <span className="text-sm text-gray-500 font-semibold">
                              {label}
                            </span>
                            <div className="flex gap-2">
                              <span className="text-base">
                                {displayValue?.value || ""}
                              </span>
                              <Button
                                size="sm"
                                variant="text"
                                icon="visibility"
                                onClick={() => {
                                  setSelectDocuments(
                                    displayValue?.metadata || [],
                                  );
                                  setDocumentModal(!documentModal);
                                }}
                              />
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div key={label} className="flex flex-col">
                          <span className="text-sm text-gray-500 font-semibold">
                            {label}
                          </span>
                          <span className="text-base">{displayValue}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-gray-500 italic">No preview data available.</p>
          )}
        </div>
        <div className="flex justify-end pt-4">
          <Button
            title={"Edit"}
            variant="contained"
            icon="edit"
            onClick={() => onEdit(previewData?.data)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Placement;
